import { useState } from "react";
import { formatCurrency, formatMinAndMaxAmount } from "utils/HelperFunctions";

/**
 * Encapsulates amount range validation and error state.
 * Returns a validator that sets error and returns true when invalid.
 */
export const useAmountValidation = (
  systemSettings: any,
  accountBalance?: number,
) => {
  const [amtErr, setAmtErr] = useState<string | null>(null);

  const validateAmount = (value: string): boolean => {
    const { min, max } = formatMinAndMaxAmount(systemSettings, accountBalance);
    const str = value.replaceAll(",", "");
    const num = parseFloat(str);
    if (isNaN(num) || num < min || num > max) {
      setAmtErr(
        `Amount should be between ${formatCurrency(min)} and ${formatCurrency(max)}`,
      );
      return true;
    }
    setAmtErr(null);
    return false;
  };

  return { amtErr, setAmtErr, validateAmount };
};
